import { useState } from 'react';
import {
  faMagnifyingGlass,
  faDownload,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfirmDocumentation } from '../confirm-documentation';
import styles from './styles.module.scss';
import type { SectionInfoProps } from './types';
import { ModalShowDoc } from '../modal-show-doc';
import SVGPdfFile from '@/Assets/Img/pdf-file.svg';

function SectionInfo({
  title,
  imageUrl,
  secondImageUrl,
  details,
  valueApprove,
  valueComment,
  customFirstImageLabel,
  customSecondImageLabel,
  disableApprove,
}: SectionInfoProps) {
  const [showModal, setShowModal] = useState(false);
  const [selectUrlImage, setSelectUrlImage] = useState('');

  const handleClickImage = (url: string) => {
    setSelectUrlImage(url);
    setShowModal(true);
  };

  const donwloadPdf = (url: string) => {
    window.open(url, '_blank');
  };

  const isPdf =
    typeof imageUrl === 'string' && imageUrl?.toLowerCase().includes('pdf');

  const isSecondImagePdf =
    typeof secondImageUrl === 'string' &&
    secondImageUrl?.toLowerCase().includes('pdf');

  return (
    <div>
      <h3>{title}</h3>
      <div className={styles.container}>
        <div className={styles.containerImages}>
          {imageUrl && (
            <div
              className={styles.containerBox}
              onClick={() =>
                isPdf ? donwloadPdf(imageUrl) : handleClickImage(imageUrl)
              }
            >
              {secondImageUrl && (
                <div className={styles.optionalText}>
                  <p>{customFirstImageLabel}</p>
                </div>
              )}
              <div role="group" className={styles.boxImage}>
                {isPdf ? (
                  <img
                    src={SVGPdfFile}
                    alt="Imagem documento"
                    aria-label="first-image"
                  />
                ) : (
                  <img
                    src={imageUrl}
                    alt="Imagem documento"
                    aria-label="first-image"
                  />
                )}
              </div>
              <div className={styles.boxZoom}>
                <FontAwesomeIcon
                  icon={isPdf ? faDownload : faMagnifyingGlass}
                />
                <p>{isPdf ? 'Baixar' : 'Zoom'}</p>
              </div>
            </div>
          )}

          {secondImageUrl && (
            <div
              className={styles.containerBox}
              onClick={() =>
                isSecondImagePdf
                  ? donwloadPdf(secondImageUrl)
                  : handleClickImage(secondImageUrl)
              }
            >
              <div className={styles.optionalText}>
                <p>{customSecondImageLabel}</p>
              </div>
              <div className={styles.boxImage}>
                {isSecondImagePdf ? (
                  <img
                    src={SVGPdfFile}
                    alt="Imagem documento"
                    aria-label="first-image"
                  />
                ) : (
                  <img
                    src={secondImageUrl}
                    alt="Imagem documento"
                    aria-label="second-image"
                  />
                )}
              </div>
              <div className={styles.boxZoom}>
                <FontAwesomeIcon
                  icon={isSecondImagePdf ? faDownload : faMagnifyingGlass}
                />
                <p>{isSecondImagePdf ? 'Baixar' : 'Zoom'}</p>
              </div>
            </div>
          )}

          {details && (
            <div className={styles.containerDetails}>
              {details.map(detail => {
                return (
                  <div className={styles.boxDetails} key={detail.key}>
                    <span>{detail.key}</span>
                    <span>{detail.value}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <ConfirmDocumentation
          valueApprove={valueApprove}
          valueComment={valueComment}
          disableApprove={disableApprove}
        />
      </div>

      {showModal && (
        <ModalShowDoc
          title={title}
          imageUrl={selectUrlImage}
          open={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export { SectionInfo };
